// Utilities
import { defineStore } from 'pinia';

export const useCookiesStore = defineStore('cookies', {
    state: () => ({
        consentGiven: null as boolean | null,
        analyticsEnabled: false as boolean,
    }),
    getters: {
        hasConsent(): boolean | null {
            return this.consentGiven;
        },
        isAnalyticsEnabled(): boolean {
            return this.analyticsEnabled;
        },
    },
    actions: {
        setConsent(consent: boolean) {
            this.consentGiven = consent;
            this.analyticsEnabled = consent;
        },
        setAnalyticsEnabled(enabled: boolean) {
            this.analyticsEnabled = enabled;
        },
        acceptAll() {
            this.setConsent(true);
        },
        rejectAll() {
            this.setConsent(false);
        },
    },
    persist: {
        pick: ['consentGiven', 'analyticsEnabled'],
        storage: localStorage,
    },
});

